/* eslint no-param-reassign: 0 */

export const confirmedRentals = $ =>
  $.cart.rentals.filter(rental => rental.confirmed);

export const guidedRentals = $ =>
  $.cart.rentals.filter(rental => rental.guideCompleted);

export default 'bar';



// WEBPACK FOOTER //
// ./src/store-methods/getters/rental.js